// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.react-trello-board {
  background: transparent;
  padding: 0;
  height: 100%;
  overflow-y: auto;
}

div.react-trello-board > div {
  height: 100%;
}

div.smooth-dnd-container {
  height: 100%;
}

section.react-trello-lane {
  max-height: 95%;
}
section.react-trello-board{
  max-height: 97.5%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/overrides/react-trello.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["div.react-trello-board {\n  background: transparent;\n  padding: 0;\n  height: 100%;\n  overflow-y: auto;\n}\n\ndiv.react-trello-board > div {\n  height: 100%;\n}\n\ndiv.smooth-dnd-container {\n  height: 100%;\n}\n\nsection.react-trello-lane {\n  max-height: 95%;\n}\nsection.react-trello-board{\n  max-height: 97.5%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
